module.exports = __webpack_public_path__ + "img/imgs-1.0dc634f5.png";